<template>
  <div class="tabs-widget">
    <div class="tab-item" :class="{ active: activeTab == 'management' }" v-if="$checkPermission('voting')"
      @click="switchTab('management')">
      VOTING MANAGMENT
    </div>
    <div class="h-spacer" v-if="$checkPermission('voting')"></div>
    <div class="tab-item" :class="{ active: activeTab == 'nominations' }" v-if="$checkPermission('voting')"
      @click="switchTab('nominations')">
      NOMINATIONS
    </div>
    <div class="h-spacer" v-if="$checkPermission('voting')"></div>
    <div class="tab-item" :class="{ active: activeTab == 'voting_topup' }" v-if="$checkPermission('voting')"
      @click="switchTab('voting_topup')">
      VOTING TOPUP
    </div>
    <div class="h-spacer" v-if="$checkPermission('voting')"></div>
    <div class="tab-item" :class="{ active: activeTab == 'voting_report' }" v-if="$checkPermission('voting')"
      @click="switchTab('voting_report')">
      VOTING REPORT
    </div>
  </div>
</template>
      
<script>
export default {
  components: {},
  sockets: {},
  props: {
    activeTab: {
      type: String,
      default: "",
    },
  },
  data: () => ({}),
  watch: {},
  mounted() {
    let vm = this;
  },
  methods: {
    switchTab(type) {
      let vm = this;
      vm.$emit("selected", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs-widget {
  display: flex;
  align-items: flex-end;
  margin-right: 15px;

  .h-spacer {
    margin-right: 20px;
  }

  .tab-item {
    cursor: pointer;
    padding: 14px 4px;
    border-bottom: 3px solid transparent;
    white-space: nowrap;

    &.active {
      color: var(--wecodefy-secondary-color, #9fc953);
      border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
    }
  }
}
</style>
      